// https://codepen.io/billdwhite/pen/zYJyNL
import "./styles.css";
import * as React from "react";
import { useSearchParams } from "react-router-dom";
import { Hooks } from "./layout/hooks";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { ApiMap } from "./api-map";
import { Legacy } from "./layout/legacy";
import { Nodes } from "./layout/nodes";
import { MapToolbar } from "./toolbar";


export function App() {
  const [toolbarEl, setToolbarEl] = React.useState<HTMLDivElement | null>(null);

  const [searchParams, setSearchParams] = useSearchParams([
    ["groups", "true"],
    ["link", "true"],
  ]);
  const toggles = [...searchParams.entries()]
    .filter(([, v]) => v)
    .map(([k]) => k);

  const showLegacy = toggles.includes("legacy");
  const scaleItems = toggles.includes("scale");

  const showLinks = toggles.includes("link");
  const showGroups = toggles.includes("groups");

  return (
    <TooltipPrimitive.Provider>
      {/* A hack, but a cool one */}
      <div ref={setToolbarEl} />
      <ApiMap>
        <MapToolbar
          toolbarEl={toolbarEl}
          toggles={toggles}
          setToggles={(newToggles: string[]) => {
            const newToggleParams = newToggles.map(
              (t) => [t, String(true)] satisfies [string, string]
            );
            setSearchParams(newToggleParams);
          }}
          showLegacy={showLegacy}
        />

        <text
          x={800}
          y={250}
          fontSize={128}
          fontFamily="monospace"
          filter="url(#text-shadow)"
          fontStretch={"condensed"}
        >
          Jules’ Map of React API
        </text>

        <Hooks
          showDivisions={showGroups}
          scaleItems={scaleItems}
          showLinks={showLinks}
        />

        {showLegacy && <Legacy />}
        <Nodes scaleItems={scaleItems} />
      </ApiMap>
      {/Apple Computer/.test(navigator.vendor) && (
        <h2 className="absolute bottom-4 left-3 w-72 max-w-full -rotate-3 rounded-md border border-stone-300 bg-red-500 py-3 px-4 text-base text-white drop-shadow-xl">
          Safari has quite a few rendering quirks and zooming and panning is
          choppy in it. This map is best viewed in Chrome, Firefox or Edge on a large screen.
        </h2>
      )}
    </TooltipPrimitive.Provider>
  );
}
